const tools = {
    handleFormat (date) {
        date = date || new Date();
        const year = date.getFullYear();
        const month = change(date.getMonth() + 1);
        const day = change(date.getDate());
        function change (t) {
            if (t < 10) {
                return '0' + t;
            } else {
                return t;
            }
        }
        const time = year + '-' + month + '-' + day;
        return time;
    },
    getWeekDate () {
        const now = new Date();
        const nowTime = now.getTime();
        const day = now.getDay();
        const oneDayTime = 24 * 60 * 60 * 1000;
        // 显示周一
        const MondayTime = nowTime - (day - 1) * oneDayTime;
        // 显示周日
        const SundayTime = nowTime + (7 - day) * oneDayTime;
        // 初始化日期时间
        let monday = new Date(MondayTime);
        let sunday = new Date(SundayTime);
        monday = this.handleFormat(monday);
        sunday = this.handleFormat(sunday);
        return `${monday},${sunday}`;
    },
    getMonthDate () {
        // 当月第一天
        let firstDate = new Date();
        firstDate.setDate(1);
        // 当月最后一天
        let endDate = new Date(firstDate);
        endDate.setMonth(firstDate.getMonth() + 1);
        endDate.setDate(0);
        firstDate = this.handleFormat(firstDate);
        endDate = this.handleFormat(endDate);
        return `${firstDate},${endDate}`;
    },
    // 处理时间
    handleTime (time) {
        let ptime = new Date(time).getTime();
    
        const twentyFourHours = 24 * 60 * 60 * 1000;
        const fortyEightHours = 24 * 60 * 60 * 1000 * 2;
        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const today = `${year}-${month}-${day}`;
        const todayTime = new Date(today).getTime();
        const yesterdayTime = new Date(todayTime - twentyFourHours).getTime();
        const lastYesterdayTime = new Date(todayTime - fortyEightHours).getTime();

        if (ptime >= todayTime) {
            return '今天 ';
        }
        else if (ptime < todayTime && yesterdayTime <= ptime) {
            return '昨天 ';
        } else if (ptime < yesterdayTime && lastYesterdayTime <= ptime) {
            return '前天 ';
        } else {
            return time.split(' ')[0];
        }
    },
    // 给img标签添加自定义属性
    setImgCustomAttr (data) {
        let resData = data;
        const imgReg = /<img\b.*?(?:\>|\/>)/gi;
        const srcReg = /src=[\'\"]([^\'\"]*)[\'\"]/i;
        const imgs = resData.match(imgReg);
        const urlReg = /(https|http):\/\/(dev.|test.)?bk.tencent.com/;
        const srcList = imgs && imgs.reduce((acc, cur) => {
            const res = cur.match(srcReg);
            if (!res || !res[1]) return acc;
            const index = cur.search(urlReg);
            if (index > -1 || res[1][0] === '/') {
                acc.push(res[1]);
            }
            return acc;
        }, []);
        srcList && srcList.forEach(item => {
            resData = resData.replace(item, `${item}?from_third_party_component=True`);
        });
        return resData;
    },
    // 转义 HTML 特殊字符，用于把纯文本拼进后续要交给 v-html 的字符串
    escapeHtml (str) {
        if (str === null || str === undefined) return '';
        const escapeMap = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
        };
        return String(str).replace(/[&<>"']/g, char => escapeMap[char]);
    }
};
export default tools;



// WEBPACK FOOTER //
// ./src/js/tools.js